"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6246],{

/***/ 49992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cq": function() { return /* binding */ AppDetailSection; },
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "IP": function() { return /* binding */ AppSectionContainer; },
/* harmony export */   "xM": function() { return /* binding */ ImageWrap; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52261);
/* harmony import */ var _ProductCategoryPage_TitleBannerSection_styled_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13179);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nwidth: 100%;\nheight: 80vh;\ndisplay: block;\nmargin-top: 30px;\n/* border: 1px solid black; */\nposition: relative;\n\n@media only screen and (max-width: 560px) {\n  display: inline-block;\n  margin-bottom: 3%;\n  height: 100vh;\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\ntext-align: center;\nfont-size: 28px;\n\n@media only screen and (max-width: 768px) {\n  font-size: 24px;\n}\n\n@media only screen and (max-width: 768px) {\n  font-size: 22px;\n  margin-bottom: 20px;\n}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nposition: absolute;\nwidth: 56%;\nheight: 60%;\nright: 0;\nmargin-top: 4%;\noverflow: hidden;\n\n@media only screen and (max-width: 560px) {\n  display: block;\n  position: relative;\n  margin: auto;\n  width: 100%;\n  /* bottom: 0; */\n  height: 50%;\n  margin-top: 4%;\n  margin-bottom: 3%;\n}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\nposition: absolute;\nleft: 120px;\nheight: 60%;\nmargin-top: 5%;\nwidth: 30%;\ncolor: black;\nwhite-space: nowrap;\n\n@media only screen and (max-width: 769px) {\n  left: 40px;\n}\n\n@media only screen and (max-width: 560px) {\n  display: block;\n  position: relative;\n  margin: auto;\n  margin-bottom: auto;\n  text-align: center;\n  height: 40%;\n  white-space: normal;\n  width: 80%;\n  left: 0px;\n}\n\n .apply {\n   font-size: 20px;\n   font-family: "Montserrat";\n   letter-spacing: 0px;\n   font-weight: 900;\n   text-align: left;\n   letter-spacing: .4px;\n  \n   @media only screen and (max-width: 560px) {\n     text-align: center;\n     font-size: 17px;\n   }\n\n   &.in-person {\n    margin-top: 10px;\n    margin-bottom: 10px;;\n   }\n\n   &.online {\n    margin-top: 50px;\n   }\n\n }\n.address {\n  font-family: "Helvetica";\n  margin-bottom: 5px;\n  font-size: 15px;\n  font-weight: 500;\n  letter-spacing: .6px;\n  color: black;\n\n  &.click>a, &.click {\n    text-decoration: underline;\n    color: black;\n    &:hover{\n      color: black;\n      cursor: pointer;\n    }\n  }\n   }\n'
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var AppSectionContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1a50da1f-0"
})(_templateObject());
var Title = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_ProductCategoryPage_TitleBannerSection_styled_js__WEBPACK_IMPORTED_MODULE_1__/* .TitleText */ .e).withConfig({
    componentId: "sc-1a50da1f-1"
})(_templateObject1());
var ImageWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1a50da1f-2"
})(_templateObject2());
var AppDetailSection = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-1a50da1f-3"
})(_templateObject3());


/***/ }),

/***/ 6246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CareersPage_GraySec; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(52261);
// EXTERNAL MODULE: ./containers/CareersPage/ApplicationSection/styled.js
var styled = __webpack_require__(49992);
;// CONCATENATED MODULE: ./containers/CareersPage/GraySec/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background-color: #f0f0f0;\n  height: 220px;\n  display: block;\n  /* margin-left: -3%; */\n  padding-top: 20px;\n\n  /* @media only screen and (max-width: 1250px) {\n  width: 100vw;\n  margin-left: -2,5%;\n} */\n  @media only screen and (max-width: 768px) {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 32px;\n  letter-spacing: 0.5px;\n\n  & > span {\n    background-image: linear-gradient(#f0f0f0 35%, rgba(255, 255, 255, 1) 0%);\n    display: inline;\n    background-position: right 0px bottom 0px;\n    padding: 0px 18px;\n  }\n\n  @media only screen and (max-width: 560px) {\n    font-size: 24px;\n    word-spacing: -3px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  text-align: center;\n  font-size: 18px;\n  color: black;\n  font-family: "Helvetica";\n  /* font-weight: bolder; */\n  line-height: 12px;\n\n  @media only screen and (max-width: 560px) {\n    line-height: normal;\n    margin-bottom: 0px;\n  }\n\n  &:first-of-type {\n    padding-top: 5%;\n  }\n'
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var GraySection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aeb48b8a-0"
})(_templateObject());
var Title1 = (0,styled_components_browser_esm/* default */.ZP)(styled/* Title */.Dx).withConfig({
    componentId: "sc-aeb48b8a-1"
})(_templateObject1());
var InfoText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-aeb48b8a-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./containers/CareersPage/GraySec/index.js



function GraySec() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GraySection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title1, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "People are Our Greatest Asset"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoText, {
                children: "If you would love a job opportunity and learn a trade or showcase your existing"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoText, {
                children: "talents, submit your resume and/or your application today!"
            })
        ]
    });
}
/* harmony default export */ var CareersPage_GraySec = (GraySec);


/***/ }),

/***/ 13179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; },
/* harmony export */   "e": function() { return /* binding */ TitleText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75190);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52261);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: auto;\n  min-height: 55px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ",
        ";\n\n  @media only screen and (max-width: 768px) {\n    min-height: 50px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  font-family: "Lora medium";\n  font-size: 35px;\n  font-weight: bold;\n  color: ',
        ";\n  letter-spacing: .55rem;\n  text-align: center;\n\n  @media only screen and (max-width: 768px) {\n    font-size: 30px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var Container = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed7fedda-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var TitleText = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed7fedda-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.darkGray2;
});


/***/ })

}]);